module.exports = __webpack_public_path__ + "static/media/E.42116f11.gif";